

import request from '@/api/request'
import requestUrl from '@/api/requestUrl'
import requestParam from '@/api/requestParam'

// get请求 自定义url
export function Get (url, params, timeout) {
  return request({
    url: requestUrl(url),
    method: 'get',
    timeout: timeout || 15 * 1000,
    params: requestParam(params, 'get')
  })
}

// path请求 自定义url
export function GetPath (url,timeout) {
  return request({
    url: requestUrl(url),
    method: 'get',
    timeout: timeout || 15 * 1000,
    params: requestParam({}, 'get')
  })
}

// post请求 自定义url
export function Post (url, params, timeout) {
  console.log(requestUrl(url))
  return request({
    url: requestUrl(url),
    method: 'post',
    timeout: timeout || 15 * 1000,
    data: requestParam(params, 'post')
  })
}

// Download 自定义url
export function Download (url, params) {
  return request({
    url: requestUrl(url),
    method: 'get',
    timeout: 99999 * 1000,
    data: requestParam(params, 'get'),
    responseType: 'arraybuffer'
  })
}

// Download 自定义url
export function DownloadForPost (url, params) {
  return request({
    url: requestUrl(url),
    method: 'post',
    timeout: 0, // 0无超时时间
    data: requestParam(params, 'post'),
    responseType: 'arraybuffer'
  })
}


export default {
  Get,        // get请求
  GetPath,    // get的path请求
  Post,       // post请求
  Download,   // get下载
  DownloadForPost, // post下载
}



// WEBPACK FOOTER //
// ./src/api/index.js